// @ts-ignore
module Accessibility {
    const $targets = document.querySelectorAll('[data-make-me-accessible]');

    function init () {
        $targets.forEach(($target: any) => {
            $target.addEventListener('keyup', (evt: KeyboardEvent) => {
                if($target.hasAttribute('data-open-full-page')){
                    if(evt.key === "Enter") {
                        $target.querySelector('a').click();
                    }
                }else{
                    if(evt.key === "Enter") {
                        $target.click();
                    }
                }

            });
        });
    }

    init();
}

export {}